import { memo } from 'react';
import Header from '@/components/header/header.component';
import Table from '@/components/table/table.component';

const MainPage = () => {
  return (
    <div className="flex h-screen w-screen flex-col">
      <Header />
      <Table />
    </div>
  );
};

export default memo(MainPage);
